import { Button } from "@coval/ui"

interface GoogleOAuthButtonProps {
  onClick: () => void
  disabled?: boolean
  label: string
}

export function GoogleOAuthButton({
  onClick,
  disabled,
  label,
}: GoogleOAuthButtonProps) {
  return (
    <Button
      type="button"
      variant="secondary"
      className="w-full"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      data-testid="signup-google-button"
    >
      <GoogleGlyph />
      <span>{label}</span>
    </Button>
  )
}

function GoogleGlyph() {
  return (
    <svg
      aria-hidden
      width={16}
      height={16}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Google's official "G" brand logo colors — fixed brand assets, must
          not be re-toned to Coval tokens. */}
      <path
        fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.2 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.8-8.7 19.8-20 0-1.2-.1-2.3-.2-3.5z"
      />
      <path
        fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.6 16 18.9 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.2 6.1 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.3 0 10.1-2 13.7-5.4l-6.3-5.3C29.3 34.9 26.8 36 24 36c-5.3 0-9.7-3.4-11.3-8l-6.6 5.1C9.6 39.5 16.3 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.3 36 44 30.5 44 24c0-1.2-.1-2.3-.4-3.5z"
      />
    </svg>
  )
}
